import { paymentMethods } from "../helperFunctions";

const makeCardPayment = async ({
    cardElement,
    paymentIntent,
    stripe,
    savedPaymentMethodType = "",
    checkoutPaymentData = {},
    paymentPopupData = {}
}) => {
    const data = {
        error: false,
        isSuccessFull: false,
        paymentMethod: null
    };
    try {
        const result = await stripe.confirmCardPayment(paymentIntent?.client_secret, {
            payment_method:
                savedPaymentMethodType === paymentMethods?.CARD
                    ? cardElement
                        ? {
                              card: cardElement,
                              billing_details: {
                                  name: paymentPopupData?.nameOnCard
                              }
                          }
                        : checkoutPaymentData?.paymentMethodID
                        ? checkoutPaymentData?.paymentMethodID
                        : {
                              card: cardElement,
                              billing_details: {
                                  name: paymentPopupData?.nameOnCard
                              }
                          }
                    : {
                          card: cardElement,
                          billing_details: {
                              name: paymentPopupData?.nameOnCard
                          }
                      }
        });
        data.isSuccessFull = result?.paymentIntent?.status?.toLowerCase() === "succeeded";
        data.paymentMethod = result?.paymentIntent?.payment_method;
        data.error = result?.error;
        return data;
    } catch (error) {
        return data;
    }
};
export { makeCardPayment };
